import { FormattedMessage } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { Props as PickerProps } from '#src/components/missions/picker/PickerOnboardingDialog/index.tsx';
import { PickerOnboardingDialog } from '#src/components/missions/picker/PickerOnboardingDialog/index.tsx';

import dailyMissionsMarqueeImgBottom from './assets/tape-daily-bw.webp';
import dailyMissionsMarqueeImgTop from './assets/tape-daily-color.webp';
import vaultMissionsMarqueeImgBottom from './assets/tape-vault-bw.webp';
import vaultMissionsMarqueeImgTop from './assets/tape-vault-color.webp';
import dialogBg from './assets/vault-mission-onboarding-bg.webp';

type Props = {
  isVaultMission?: boolean;
  onClose: () => void;
};

const footballProps = {
  greenText: <FormattedMessage defaultMessage="Win rewards!" />,
  mainText: <FormattedMessage defaultMessage="Pick 3 Players" />,
} as Omit<PickerProps, 'onClose'>;

const nbaProps = {
  greenText: <FormattedMessage defaultMessage="Win rewards!" />,
  secondaryText: <FormattedMessage defaultMessage="Can They GET IT DONE?" />,
} as Omit<PickerProps, 'onClose'>;

const dailyOrVaultProps = {
  daily: {
    mainText: <FormattedMessage defaultMessage="Pick 3 Players" />,
    marqueeImgTop: dailyMissionsMarqueeImgTop,
    marqueeImgBottom: dailyMissionsMarqueeImgBottom,
  },
  vault: {
    dialogBg,
    mainText: <FormattedMessage defaultMessage="Pick 3 sealed Players" />,
    marqueeImgTop: vaultMissionsMarqueeImgTop,
    marqueeImgBottom: vaultMissionsMarqueeImgBottom,
  },
};

export const DecisivePlayerPickerOnboardingDialog = ({
  isVaultMission = false,
  onClose,
}: Props) => {
  const { sport } = useSportContext();
  const propsBySport = {
    [Sport.FOOTBALL]: footballProps,
    [Sport.NBA]: nbaProps,
    [Sport.BASEBALL]: nbaProps,
  };

  return (
    <PickerOnboardingDialog
      onClose={onClose}
      {...propsBySport[sport]}
      {...(isVaultMission ? dailyOrVaultProps.vault : dailyOrVaultProps.daily)}
    />
  );
};
